import React, { useState } from "react";

const CookiePopup = ({ onAccept, onDecline }) => {
  const [closing, setClosing] = useState(false);

  const handleAccept = () => {
    setClosing(true);
    setTimeout(() => onAccept(), 250);
  };

  const handleDecline = () => {
    setClosing(true);
    setTimeout(() => onDecline(), 250);
  };

  return (
    <div
      className={`fixed inset-0 z-[99999] flex items-end justify-center transition-opacity duration-300 font-epilogue ${closing ? "opacity-0" : "opacity-100"
        }`}
    >

      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-50 mb-6 w-full flex justify-center">
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 max-w-6xl w-[95%] flex flex-col md:flex-row items-center justify-between gap-4">

          <p className="text-sm text-gray-600 leading-relaxed md:text-left text-center">
            We use cookies to enhance your experience on our website. By clicking
            'Accept', you consent to the use of cookies as described in our Cookie
            Policy. If you choose to decline, only essential cookies will be used.
          </p>
          <div className="flex items-center gap-3">
            <button
              onClick={handleAccept}
              className="bg-[#1E72BB] text-white px-6 py-2 rounded-lg font-medium hover:bg-[#003ae6] transition"
            >
              Accept
            </button>

            <button
              onClick={handleDecline}
              className="border border-gray-300 text-gray-900 font-semibold px-6 py-2 rounded-lg hover:bg-gray-100 transition"
            >
              Decline
            </button>

          </div>

        </div>
      </div>
    </div>

  );
};

export default CookiePopup;
